import createScheduler from '@/polyfills/create-scheduler';

const EXPIRE_SECONDS = 5;

class AdminCache extends Map {
  constructor() {
    super();
    const cache = localStorage.getItem('adminCache');
    if (cache) {
      const parsedCache = JSON.parse(cache);
      for (const [key, value] of Object.entries(parsedCache)) {
        this.set(key, value);
      }
    }
  }

  use(url: string, ttlSeconds = EXPIRE_SECONDS) {
    const expireAt = super.get(url);
    this.keep();

    if (expireAt && expireAt > Date.now()) {
      return 'force-cache';
    } else if (expireAt) {
      super.delete(url);
    }

    this.set(url, Date.now() + 1000 * ttlSeconds);
    return 'reload';
  }

  keep() {
    const taskScheduler = createScheduler();
    taskScheduler.schedule(
      () => {
        localStorage.setItem('adminCache', JSON.stringify(Object.fromEntries(this.entries())));
      },
      {
        delay: 0,
        priority: 'background',
      }
    );
  }

  clear(path?: string) {
    if (path) {
      super.delete(path);
      return;
    }
    super.clear();
  }
}

export default new AdminCache();
